/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import Dialog from '@mui/material/Dialog';
import { Slide } from '@mui/material';
import { forwardRef } from 'react';
import DlgContent from './dlgContent';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function TransferActivation({ macAddress, dialog, transferCount }) {
  return (
    <>
      <Dialog
        keepMounted={false}
        open={dialog.value}
        onClose={dialog.onFalse}
        scroll="body"
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DlgContent macAddress={macAddress} dialog={dialog} transferCount={transferCount} />
      </Dialog>
    </>
  );
}
